import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { Navigate } from 'react-router';

const AuditLog = lazy(() => import('./pages/AuditLog'));
const SystemHealth = lazy(() => import('./pages/SystemHealth'));
const UserManagement = lazy(() => import('./pages/UserManagement'));
const AdminAnalytics = lazy(() => import('./pages/AdminAnalytics'));

export const adminRoutes: RouteObject = {
  path: 'admin',
  handle: { breadcrumb: 'Admin' },
  children: [
    { index: true, element: <Navigate to="audit" replace /> },
    { path: 'audit', element: <AuditLog />, handle: { breadcrumb: 'Audit Log' } },
    { path: 'health', element: <SystemHealth />, handle: { breadcrumb: 'System Health' } },
    { path: 'users', element: <UserManagement />, handle: { breadcrumb: 'User Management' } },
    { path: 'analytics', element: <AdminAnalytics />, handle: { breadcrumb: 'Analytics' } },
  ],
};
